export default "__VITE_ASSET__nFJVjxi5__"